import { all, call, put, SagaReturnType, select, takeEvery } from '@redux-saga/core/effects';
import { PayloadAction } from "@reduxjs/toolkit";
import { OpService } from '../../util/services/operation';
import { VesselService } from "../../util/services/vessel";
import { selectSite } from '../../util/store/site/constants';
import { checkOpInSite } from '../../util/varibles/global';
import { ISite } from '../../util/varibles/interface';
import { dashboardActions } from "./reducer";

function* getDashboardWatcher() {
    try {
        const { operations } = yield call(OpService.getDashboardOperations) || {};
        yield put(dashboardActions.getDataSuccess(operations));
    } catch (error) {
        yield put(dashboardActions.getDataFailure());
        console.log(error)
    }
}

function* getVesselsWatcher(props: PayloadAction<Function | undefined>): Generator<any, any, any> {
    try {
        const contracts: SagaReturnType<typeof VesselService.getByContracts> = yield call(VesselService.getByContracts);
        const iotNames = (contracts || []).map((item: any) => item.iot_name);

        const positions: SagaReturnType<typeof VesselService.getPositions> = iotNames.length > 0
            ? yield call(VesselService.getPositions, iotNames)
            : [];

        const vessels = (positions || []).reduce((list: any, gps: any) => {
            const { time, ...args } = gps;
            const [value] = time.split('.');
            const gpsTime = value[value.length - 1] === 'Z' ? new Date(value.replace(' ', 'T')).getTime() :
                new Date(value.replace(' ', 'T') + 'Z').getTime();

            const vessel = contracts.find(item => item.id.indexOf(gps.vessel_id) !== -1);
            if (!vessel) return list;
            const index = list.findIndex((item: any) => item.id === vessel.id);
            const data = { ...vessel, gps: { ...args, time: gpsTime } };
            if (index === -1)
                return [...list, data];
            else {
                list[index] = data;
                return list
            }
        }, []);

        const callback = props.payload;
        if (callback)
            callback(vessels);

        yield put(dashboardActions.getVesselsSuccess(vessels))
    } catch (error) {
        yield put(dashboardActions.getVesselsFailure());
    }
}
function* updateOpsSiteByWsWatcher(props: ReturnType<typeof dashboardActions.updateOpsSiteByWs>): any {
    try {
        const ops = props.payload;
        const sites: ISite[] = yield select(selectSite.dashboard);
        const siteIds = new Set(sites.map(s => s.id))
        const result = ops.filter(item => {
            const { [item.operation.operation_type]: funcCheck } = checkOpInSite;
            return funcCheck && funcCheck(item.operation, siteIds).length > 0;
        }, [])
        yield put(dashboardActions.updateOpsSite(result))
    } catch (error) {
        console.log("Update operations of site failure", error)
    }
}
export default function* dashboardSaga() {
    yield all([
        takeEvery(dashboardActions.getDataRequest.type, getDashboardWatcher),
        takeEvery(dashboardActions.getVesselsRequest.type, getVesselsWatcher),
        takeEvery(dashboardActions.updateOpsSiteByWs.type, updateOpsSiteByWsWatcher),
    ])
}
